import { ItalicText } from './ItalicText'
import { StrikeText } from './StrikeText'
import { BoldText } from './BoldText'
import { CodeElement } from './CodeElement'
import { Emoji } from './Emoji'
import { ColorElement } from './ColourElement'
import { LinkText } from './LinkText'
import { Typography } from '@eventr/common-storybook'

// const InlineElements = ({ contents }) =>
export function InlineElements(contents) {
    return contents.contents.map((content, index) => {
        if (content.type === 'BOLD') {
            return <BoldText key={index} contents={content.value} />
        } else if (content.type === 'PLAIN_TEXT') {
            return (
                <Typography
                    key={index}
                    variant="bodyRegular"
                    style={{ wordWrap: 'break-word' }}
                >
                    {content.value}
                </Typography>
            )
        } else if (content.type === 'STRIKE') {
            return <StrikeText key={index} contents={content.value} />
        } else if (content.type === 'ITALIC') {
            return <ItalicText key={index} contents={content.value} />
        } else if (content.type === 'INLINE_CODE') {
            return <CodeElement key={index} contents={content.value} />
        } else if (content.type === 'EMOJI') {
            return <Emoji key={index} emoji={content} />
        } else if (content.type === 'COLOR') {
            return <ColorElement key={index} {...content.value} />
        } else if (content.type === 'LINK') {
            return (
                <LinkText
                    key={index}
                    href={content.value.src.value}
                    label={
                        Array.isArray(content.value.label)
                            ? content.value.label
                            : [content.value.label]
                    }
                />
            )
        } else {
            return <div />
        }
    })
}
